import React from 'react'
import ReciveInvoicesContent from '../../Component/ReciveInvoicesContent/ReciveInvoicesContent'
import Sidebar from '../../Component/Sidebar/Sidebar'
import Header from '../../Component/Header/Header'

function ReciveInvoices() {
  return (
    <div className="apDiv reciveInvoices">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>
        <ReciveInvoicesContent />
      </div>
    </div>
  )
}

export default ReciveInvoices
